import React, { useEffect } from 'react'
import Animated, {
  useSharedValue,
  useAnimatedStyle,
  withSequence,
  withTiming,
} from 'react-native-reanimated'
import { useTheme } from 'styled-components/native'

import Styles from './style'
import Typography from 'APP/Converse/Typography'

type InfoTextProps = {
  value: string
  color?: string
}

const InfoTextValue = ({ color, value }: InfoTextProps) => {
  const opacity = useSharedValue(1)
  const theme = useTheme()

  const animatedStyle = useAnimatedStyle(() => ({
    opacity: opacity.value,
  }))

  useEffect(() => {
    if (value) {
      opacity.value = withSequence(
        withTiming(0.3, { duration: 150 }),
        withTiming(1, { duration: 150 })
      )
    }
  }, [value, opacity])

  return (
    <Animated.View
      style={[
        Styles.infoTextItem,
        { backgroundColor: color || theme.colors.background },
        animatedStyle,
      ]}
    >
      <Typography style={Styles.infoText}>{value}</Typography>
    </Animated.View>
  )
}

export default InfoTextValue
